import profileService from "../services/profile.service";

const initialState = { profile: null };

export const profile = {
  namespaced: true,
  state: initialState,
  actions: {
    async getProfile({ commit }) {
      try {
        const response = await profileService.getProfile();
        commit("SET_PROFILE", response);
        return response;
      } catch (e) {
        commit("SET_PROFILE", null);
        return null;
      }
    },

    async uploadPic(_, object) {
      return await profileService.uploadPic(object);
    },

    async updateProfile({ commit }, profile) {
      const response = await profileService.updateProfile(profile);
      commit("SET_PROFILE", response);
    },

    async updateTipster(context, tipster) {
      return await profileService.updateTipster(tipster);
    },

    async updateTipsterStripe(context, data) {
      return await profileService.updateTipsterStripe(data);
    },

    async testStripe() {
      return await profileService.testStripe();
    },

    async suscripcionesActivas() {
      return await profileService.suscripcionesActivas();
    },
  },

  mutations: {
    SET_PROFILE(state, profile) {
      state.profile = profile;
    },
    RESET_PROFILE(state) {
      state.profile = null;
    },
  },

  getters: {
    profile(state) {
      return state.profile;
    },
  },
};
